<app-header [forceLightBackground]="true"></app-header>
<div class="provider-upload-metadata">
  <div class="provider-upload-metadata--layout">
    <app-org-admin-sidebar *ngIf="isOrgAdminRoute" class="provider-upload-metadata--sidebar"></app-org-admin-sidebar>
    <app-provider-sidebar *ngIf="!isOrgAdminRoute" class="provider-upload-metadata--sidebar"></app-provider-sidebar>
    <div class="provider-upload-metadata--content">
      <app-page-header></app-page-header>
      <div class="upload-metadata-container">
        <!-- Step 2 Template -->
        <ng-template #step2Template>
          <form [formGroup]="uploadMetadataForm">
            <div class="step-content">
              <h2 class="step-title">Upload Metadata</h2>
              
              <!-- Dataset Information Fields (Disabled) -->
              <div *ngIf="datasetData" class="form-fields">
                <div class="form-row">
                  <!-- Title Field (Disabled) -->
                  <div class="form-field col-6">
                    <label for="dataset-title" class="form-label">
                      Title <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="dataset-title"
                      [value]="datasetData.title"
                      class="form-input"
                      disabled
                    />
                  </div>

                  <!-- Permission Field (Disabled) -->
                  <div class="form-field col-6">
                    <label for="dataset-permission" class="form-label">
                      Permission <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="dataset-permission"
                      [value]="getPermissionDisplayLabel(datasetData.permission)"
                      class="form-input"
                      disabled
                    />
                  </div>
                </div>
                
                <!-- HR Line -->
                <hr class="form-divider" />
              </div>

              <!-- Upload Metadata Section -->
              <div class="form-fields">
                <div class="form-row">
                  <div class="form-field col-12">
                    <div class="form-label-row">
                      <label for="json-schema" class="form-label">
                        JSON Schema <span class="required">*</span>
                      </label>
                      <div class="template-download-menu">
                        <ng-container *ngIf="isModel(); else dropdownTemplate">
                          <button
                            type="button"
                            class="btn-download-template"
                            title="Download metadata template"
                            (click)="downloadTemplateFormat('json', $event)"
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8 11V2M8 11L5 8M8 11L11 8M2 13.5H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            Download Template
                          </button>
                        </ng-container>
                        <ng-template #dropdownTemplate>
                          <button
                            type="button"
                            class="btn-download-template"
                            [attr.aria-expanded]="templateMenuOpen"
                            aria-haspopup="menu"
                            title="Download metadata template"
                            (click)="toggleTemplateMenu($event)"
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8 11V2M8 11L5 8M8 11L11 8M2 13.5H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            Download Template
                            <svg class="template-download-menu__chevron" [class.template-download-menu__chevron--open]="templateMenuOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">
                              <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </button>
                          <div *ngIf="templateMenuOpen" class="template-download-menu__panel" role="menu" (click)="$event.stopPropagation()">
                            <button type="button" role="menuitem" class="template-download-menu__option" (click)="downloadTemplateFormat('json', $event)">JSON</button>
                            <button type="button" role="menuitem" class="template-download-menu__option" (click)="downloadTemplateFormat('csv', $event)">CSV</button>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                    <p class="form-description">
                      <ng-container *ngIf="isModel(); else datasetDescription">
                        Upload a JSON metadata file to populate fields automatically. Download a template to see the required format.
                      </ng-container>
                      <ng-template #datasetDescription>
                        Upload a JSON or CSV metadata file to populate fields automatically. Download a template to see the required format.
                      </ng-template>
                    </p>
                    <!-- Drag and Drop Upload Area -->
                    <div 
                      *ngIf="!selectedFile && !restoredFileInfo"
                      class="drop-area"
                      [class.active]="dragActive"
                      (dragover)="onDragOver($event)"
                      (dragleave)="onDragLeave($event)"
                      (drop)="onDrop($event)"
                      (click)="triggerFileInput()"
                    >
                      <div class="drop-message">
                        <svg class="drop-icon" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M7 10L12 5L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12 5V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <p class="drop-text">
                          Drag and drop your JSON file here or
                          <button
                            type="button"
                            class="browse-button"
                            (click)="triggerFileInput(); $event.stopPropagation()"
                          >
                            browse
                          </button>
                        </p>
                        <p class="file-types-hint">
                          Allowed File Type: <span class="file-types">JSON</span> (Max size: 10MB)
                        </p>
                      </div>
                      <input
                        #fileInput
                        type="file"
                        accept=".json,application/json"
                        (change)="onFileSelected($event)"
                        class="file-input"
                      />
                    </div>
                    <!-- Selected File Display -->
                    <div *ngIf="selectedFile || restoredFileInfo" class="selected-file">
                      <div class="file-info">
                        <svg class="file-icon" width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div class="file-details">
                          <span class="file-name">{{ selectedFile?.name || restoredFileInfo?.name }}</span>
                          <span class="file-size">{{ formatFileSize(selectedFile?.size ?? restoredFileInfo?.size ?? 0) }}</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="btn-remove-file"
                        (click)="removeFile()"
                        title="Remove file"
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                    </div>
                    <!-- Error message for file upload validation -->
                    <div
                      *ngIf="uploadError"
                      class="error-message upload-error-message"
                    >
                      {{ uploadError }}
                      <ul *ngIf="missingFields.length > 0" class="missing-fields-list">
                        <li *ngFor="let field of missingFields">{{ field }}</li>
                      </ul>
                    </div>
                    <!-- Error message for form validation -->
                    <div
                      *ngIf="uploadMetadataForm.get('jsonSchema')?.invalid && uploadMetadataForm.get('jsonSchema')?.touched && !uploadError"
                      class="error-message"
                    >
                      JSON schema file is required
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ng-template>

        <!-- Stepper Component -->
        <app-stepper
          [steps]="stepperStepsWithLabel"
          [currentStep]="currentStep"
          [disableNextButton]="isNextButtonDisabled()"
          (stepChange)="onStepChange($event)"
          (next)="onNext()"
          (previous)="onPrevious()"
        ></app-stepper>
      </div>
    </div>
  </div>
</div>
